<template>
  <div class="content-430">
    <div class="title-block">
      <p>{{ areaName }}校内课后服务综合管理平台</p>
      <p>{{ yearTermName }}退款确认单</p>
    </div>
    <div class="top-block">
      <div class="top-left">
        <div class="left-line">
          <span>收款单位</span>
          <span>{{ orgName }}</span>
        </div>
        <div class="left-line">
          <span>统计日期</span>
          <span>{{ timeStartShow }} 至 {{ timeEndShow }}</span>
        </div>
        <div class="left-line">
          <span>金额</span>
          <span>人民币元</span>
        </div>
      </div>
      <div class="btn-box">
        <Button
          v-if="sheetSts===2"
          class="btn-download"
          disabled
          style="margin-right: 16px"
        >申请单已确认</Button>
        <Button
          v-if="sheetSts===1"
          class="btn-download"
          type="success"
          style="margin-right: 16px"
          :loading="confimLoading"
          @click="openCodeModal"
        >申请单无误，教务提交确认</Button>
        <Button
          class="btn-download"
          type="primary"
          style="margin-right: 16px"
          :loading="downloadLoading"
          @click="handleDownload"
        >下载</Button>
        <Dropdown placement="bottom-end" transfer-class-name="settlement-move" :transfer="true">
          <a href="javascript:void(0)">
            更多
            <Icon type="ios-arrow-down"></Icon>
          </a>
          <DropdownMenu slot="list">
            <DropdownItem v-if="sheetSts===2">
              <div class="btn-block">
                <Button long type="error" @click="handleOpenRevoke">有误，撤销确认</Button>
              </div>
            </DropdownItem>
            <DropdownItem>
              <div class="btn-block">
                <Button long @click="handleDownloadRec">操作日志</Button>
              </div>
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
    </div>
    <div class="table-box">
      <Table
        ref="tableRef"
        border
        :columns="columnTable"
        :data="tableData"
        :loading="tableLoading"
        show-summary
        :summary-method="handleSummary"
      >
        <template slot="noonTutelageAmt" slot-scope="{ row }">
          {{ row.noonTutelageAmt | showFee }}
        </template>
        <template slot="eveningTutelageAmt" slot-scope="{ row }">
          {{ row.eveningTutelageAmt | showFee }}
        </template>
        <template slot="eveningStudyAmt" slot-scope="{ row }">
          {{ row.eveningStudyAmt | showFee }}
        </template>
        <template slot="materialAmt" slot-scope="{ row }">
          {{ row.materialAmt | showFee }}
        </template>
        <template slot="courseAmt" slot-scope="{ row }">
          {{ row.courseAmt | showFee }}
        </template>
        <template slot="totalAmt" slot-scope="{ row }">
          {{ row.totalAmt | showFee }}
        </template>
        <template slot="action" slot-scope="{ row }">
          <span
            class="ordinary-color-430"
            @click="handleToOrderList(row)"
          >查看明细</span>

        </template>
      </Table>
    </div>
    <div class="bottom-block">
      <div class="bottom-item">
        <div class="item-line">平台审核人：</div>
        <div class="item-line">(签章处)</div>
        <div class="date-line">年&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;月&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;日</div>
      </div>
      <div class="bottom-item">
        <div class="item-line">学校审核人：</div>
        <div class="item-line">(签章处)</div>
        <div class="date-line">年&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;月&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;日</div>
      </div>
    </div>
    <RecModal ref="recModalRef" :code-type-map="codeTypeMap" :has-download="true"></RecModal>
    <LoadingModal
      ref="loadingModal"
      modal-title="提示"
      :modal-content="loadingModalContent"
    ></LoadingModal>
    <CheckCodeModal
      ref="checkCodeModalRef"
      check-type="req_refund_sheet_confirm"
      modal-title="退款确认申请单"
      modal-text="请仔细核对退款的申请单，确认后系统即根据【退款内容】确认，是否确认该操作？"
      @sendCode="getPhoneCode"
    ></CheckCodeModal>
    <CheckCodeModal
      ref="checkCodeRevoke"
      check-type="req_refund_sheet_revoke"
      modal-title="提示"
      modal-text="撤销后，将变更确认单状态。是否确认撤销退款确认单？"
      @sendCode="getRevokeCode"
    ></CheckCodeModal>
    <ResultModal
      ref="resultModal"
      :modal-type="modalType"
      :modal-text="resultModalText"
    ></ResultModal>
  </div>
</template>
<script>
import orderCenterApi from '@/request/orderCenter/index.js';
import { moneyFenChangeYuan } from '@/utils/utils';
import cateringAdmin from '@/request/cateringAdmin/index.js';
import RecModal from '@c/RecModal.vue';
import CheckCodeModal from './components/CheckCodeModal.vue';
import LoadingModal from './components/LoadingModal';
import ResultModal from './components/ResultModal';
import educationAdminApi from '@/request/educationAdmin/index.js';
export default {
  components: {
    CheckCodeModal,
    LoadingModal,
    ResultModal,
    RecModal
  },
  filters: {
    showFee(fee) {
      return moneyFenChangeYuan(fee);
    }

  },
  data() {
    return {
      sheetSts: 0,
      downloadLoading: false,
      sheetId: this.$route.query.sheetId,
      orgId: this.$route.query.orgId,
      columnTable: [{
        title: '序号',
        key: 'order',
        minWidth: 80,
        align: 'center'
      },
      {
        title: '学校名称',
        key: 'orgName',
        minWidth: 200,
        align: 'center'
      },
      {
        title: '午托费退款金额',
        slot: 'noonTutelageAmt',
        key: 'noonTutelageAmt',
        minWidth: 150,
        align: 'center'
      },
      {
        title: '基本托管费退款金额',
        slot: 'eveningTutelageAmt',
        key: 'eveningTutelageAmt',
        minWidth: 200,
        align: 'center'
      },
      {
        title: '晚自修费用退款金额',
        slot: 'eveningStudyAmt',
        key: 'eveningStudyAmt',
        minWidth: 200,
        align: 'center'
      }, {
        title: '材料费退款金额',
        slot: 'materialAmt',
        key: 'materialAmt',
        minWidth: 150,
        align: 'center'
      }, {
        title: '素质课程费退款金额',
        slot: 'courseAmt',
        key: 'courseAmt',
        minWidth: 180,
        align: 'center'
      }, {
        title: '退款合计',
        slot: 'totalAmt',
        key: 'totalAmt',
        minWidth: 120,
        align: 'center'
      }, {
        title: '操作',
        slot: 'action',
        minWidth: 150,
        align: 'center',
        fixed: 'right'
      }],
      tableData: [],
      tableLoading: false,
      titleInfo: {},
      yearTermName: '',
      areaName: '',
      orgName: '',
      timeStart: '',
      timeEnd: '',
      confimLoading: false,
      loadingModalContent: '',
      modalType: 0,
      resultModalText: '',
      portOrg: localStorage.getItem('portOrg'),
      codeTypeMap: {
        'REQUEST_REFUND_SHEET@DOWN_FILE_REC': '退款确认单PDF下载',
        'REQUEST_REFUND_SHEET@ADD': '退款申请单生成',
        'REQUEST_REFUND_SHEET@CONFIRM': '退款申请单确认',
        'REQUEST_REFUND_SHEET@REVOKE': '退款确认单撤销'
      }
    };
  },
  computed: {
    timeStartShow() {
      if (this.timeStart) {
        return this.formatDate(this.timeStart);
      } else {
        return '-';
      }
    },
    timeEndShow() {
      if (this.timeEnd) {
        return this.formatDate(this.timeEnd);
      } else {
        return '-';
      }
    }
  },
  created() {
    this.getSheetDetails();
  },
  methods: {
    formatDate(time) {
      const newTime = /\d{4}-\d{2}-\d{2}/g.exec(time);
      return newTime[0];
    },
    // 操作日志
    handleDownloadRec() {
      this.$refs.recModalRef.handleShow({
        recType: 'REQUEST_REFUND_SHEET@',
        objectId: this.sheetId
      });
    },
    async getAreaName(orgId) {
      const params = {
        eduId: orgId
      };
      const res = await educationAdminApi.getEduAreaName(params);
      if (res.status === 200) {
        this.areaName = res.message.areaName;
      }
    },
    // 获取请款单详情
    async getSheetDetails() {
      const res = await orderCenterApi.getSheetDetailApi({
        sheetId: this.sheetId
      });
      if (res.status === 200) {
        this.tableData = [{
          order: 1,
          ...res.message
        }];
        this.yearTermName = res.message.yearTermName;

        this.orgName = res.message.orgName;

        this.sheetSts = +res.message.sheetSts;
        if (!res.message.refundApplyTimeBegin) {
          this.timeStart = res.message.leaveTimeBegin;
          this.timeEnd = res.message.leaveTimeEnd;
        } else if (!res.message.leaveTimeBegin) {
          this.timeStart = res.message.refundApplyTimeBegin;
          this.timeEnd = res.message.refundApplyTimeEnd;
        } else {
          this.timeStart = new Date(res.message.refundApplyTimeBegin).getTime() > new Date(res.message.leaveTimeBegin).getTime() ? res.message.leaveTimeBegin : res.message.refundApplyTimeBegin;
          this.timeEnd = new Date(res.message.refundApplyTimeEnd).getTime() > new Date(res.message.leaveTimeEnd).getTime() ? res.message.refundApplyTimeEnd : res.message.leaveTimeEnd;
        }
        this.getAreaName(res.message.orgId);
      }
    },
    handleSummary({ columns, data }) {
      const sums = {};
      columns.forEach((column, index) => {
        const key = column.key;
        const slot = column.slot;
        if (key === 'order' || slot === 'action') {
          sums[key] = {
            key,
            value: ' '
          };
          return;
        }
        if (key === 'orgName') {
          sums[key] = {
            key,
            value: '合计'
          };
          return;
        }
        const values = data.map(item => Number(item[key]));
        if (!values.every(value => isNaN(value))) {
          const v = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[key] = {
            key,
            value: v || v === 0 ? moneyFenChangeYuan(v) : '-'
          };
        } else {
          sums[key] = {
            key,
            value: 'N/A'
          };
        }
      });

      return sums;
    },
    async getPdfFileId() {
      return new Promise(async(resolve, reject) => {
        try {
          const res = await orderCenterApi.getSheetDetailPdfFileApi({
            sheetId: this.sheetId
          });
          if (res.status === 200) {
            resolve(res.message);
          } else {
            reject(false);
          }
        } catch (err) {
          reject(err);
        }
      });
    },
    async handleDownload() {
      if (+this.sheetSts === 1) {
        this.$Modal.info({
          title: '提示',
          content: '申请单未确认，请先确认申请单。'
        });
        return;
      }
      this.downloadLoading = true;
      try {
        const fileId = await this.getPdfFileId();
        const downloadUrl = await this.getDownloadtoken(fileId);
        // return;
        const href = `${downloadUrl}?fileId=${fileId}`;
        const downloadElement = document.createElement('a');
        downloadElement.style.display = 'none';
        downloadElement.href = href;
        // downloadElement.download = '测试'; // 下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); // 点击下载
        document.body.removeChild(downloadElement); // 下载完成移除元素
      } finally {
        this.downloadLoading = false;
      }
    },
    // 下载token
    async getDownloadtoken(fileId) {
      return new Promise(async(resolve, reject) => {
        const params = {
          fileId: [fileId]
        };
        const res = await cateringAdmin.getDownloadtoken(params);
        if (res.status === 200) {
          resolve(res.message.downUrl);
        }
      });
    },
    handleToOrderList({ sheetId, totalAmt, orgName, yearCode,
      termCode, areaCode, orgId,
      sheetSts
    }) {
      this.$router.push({
        name: 'orderCenter_afterSale_refundApplicationList_refundApplicationOrderList',
        query: {
          sheetId, totalAmt, timeStart: this.timeStart, timeEnd: this.timeEnd, orgName,
          areaName: this.areaName,
          yearCode,
          termCode, areaCode, schoolId: orgId,
          sheetSts
        }
      });
    },
    openCodeModal() {
      this.$refs.checkCodeModalRef.handleOpen();
    },
    // 打开弹窗
    openModal(type) {
      this.$nextTick(() => {
        this.$refs[type].open();
      });
    },
    // 关闭弹窗
    closeModal(type) {
      this.$nextTick(() => {
        this.$refs[type].close();
      });
    },
    // 输入验证码之后确认退款申请单
    async getPhoneCode(code) {
      const params = {
        sheetId: this.sheetId,
        smsCode: code
      };
      this.confimLoading = true;
      this.loadingModalContent = '退款申请单确认中';
      this.openModal('loadingModal');
      try {
        const res = await orderCenterApi.confirmRequestRefundSheetApi(params);
        this.$refs.checkCodeModalRef.setErrorStr('');
        this.closeModal('loadingModal');
        if (res.status === 200) {
          this.$refs.checkCodeModalRef.handleClose();
          this.modalType = 1;
          this.resultModalText = '退款申请单确认成功';
          this.openModal('resultModal');
          this.getSheetDetails();
        } else if (res.status === 3505 || res.status === 3504) {
          this.$refs.checkCodeModalRef.setErrorStr(res.error);
        } else {
          this.resultModalText = res.error ? res.error : '退款申请单确认失败！请刷新后重新发起!';
          this.modalType = -1;
          this.openModal('resultModal');
          this.$refs.checkCodeModalRef.handleClose();
        }
      } finally {
        this.confimLoading = false;
        this.closeModal('loadingModal');
      }
    },
    handleOpenRevoke() {
      this.$refs.checkCodeRevoke.handleOpen();
    },
    async getRevokeCode(code) {
      const params = {
        sheetId: this.sheetId,
        smsCode: code
      };
      this.confimLoading = true;
      this.loadingModalContent = '退款确认单撤销中';
      this.openModal('loadingModal');
      try {
        const res = await orderCenterApi.revokeRequestRefundSheetApi(params);
        this.$refs.checkCodeRevoke.setErrorStr('');
        this.closeModal('loadingModal');
        if (res.status === 200) {
          this.$refs.checkCodeRevoke.handleClose();
          this.modalType = 1;
          this.resultModalText = '退款确认单撤销成功';
          this.openModal('resultModal');
          this.getSheetDetails();
        } else if (res.status === 3505 || res.status === 3504) {
          this.$refs.checkCodeRevoke.setErrorStr(res.error);
        } else {
          this.resultModalText = res.error ? res.error : '退款确认单撤销失败！请刷新后重新发起!';
          this.modalType = -1;
          this.openModal('resultModal');
          this.$refs.checkCodeRevoke.handleClose();
        }
      } finally {
        this.confimLoading = false;
        this.closeModal('loadingModal');
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.title-block{
  p{
    text-align: center;
    font-size: 22px;
    font-weight: bold;
    line-height: 34px;
  }
}
.top-block{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 20px;
  .top-left{
    .left-line{
      margin-bottom: 16px;
      span:nth-of-type(1){
        font-weight: bold;
        display: inline-block;
        width: 86px;
        text-align: right;
        padding-right: 12px;
      }
    }
  }
}
.table-box{
  margin-top: 30px;
}
.bottom-block{
  display: flex;
  justify-content: space-around;
  margin-top: 180px;
  padding-bottom: 100px;
  .bottom-item{
    .item-line{
      margin-bottom: 30px;
    }
    .date-line{
      margin-left: 50px;
    }
  }
}
.btn-block{
  width: 130px;
}
</style>
